module.exports = __webpack_public_path__ + "images/stickers/pete-music@2x.48403aa123895c4d64fa.png";